import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from "../api/AxiosClient";

export interface SystemMessage {
  message_id: number;
  system_message: string;
  message_type: "ALERT" | "WARNING" | "INFO";
  is_display: 0 | 1;
}

interface SystemMessagesResponse {
  result: SystemMessage[];
}

export interface MaintenanceState {
  messages: SystemMessage[];
  loading: boolean;
}

const initialState: MaintenanceState = {
  messages: [],
  loading: false,
};

/**
 * Async thunk to fetch system messages from /system-messages endpoint
 */
export const fetchSystemMessages = createAsyncThunk(
  "maintenance/fetchMessages",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get<SystemMessagesResponse>("/system-messages");
      return response.data.result;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || err.message || "Failed to fetch system messages"
      );
    }
  }
);

const maintenanceSlice = createSlice({
  name: "maintenance",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSystemMessages.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSystemMessages.fulfilled, (state, action) => {
        state.loading = false;
        state.messages = action.payload.filter((msg) => msg.is_display === 1);
      })
      .addCase(fetchSystemMessages.rejected, (state) => {
        state.loading = false;
        state.messages = [];
      });
  },
});

export default maintenanceSlice.reducer;
